<template>
<div role="button" class="toggler" :class="{active: visible}" type="button" @click="$emit('click')">
  <span class="toggler__left"></span>
  <span class="toggler__right"></span>
</div>
</template>

<script>
export default {
    props: {
        visible: Boolean
    }
}
</script>

<style lang="scss" scoped>
$easing: cubic-bezier(.25,1.7,.35,.8);
$duration: 0.5s;

.toggler {
  position: relative;
  height: 50px;
  width: 50px;
  display:flex;
  justify-content: center;
  padding: 0 4px 0 0;
  cursor: pointer;
  transform: rotate(-90deg) translateY(50%);
  transform-origin: center center;
  border-radius: 4px;

  &__left {
    background-color: transparent;
    top: 0;
    left:0;
    width: 15px;
    height: 4px;
    display: block;
    transform: rotate(35deg);
    float: right;
    border-radius: 2px;

    &:after {
      content:"";
      background-color: white;
      width: 15px;
      height: 4px;
      display: block;
      float: right;
      border-radius: 10px 10px 10px 10px;
      transition: all $duration $easing;
      z-index: -1;
    }
  }

  &__right {
    position: absolute;
    background-color: transparent;
    top: 0px;
    left:26px;
    width: 15px;
    height: 4px;
    display: block;
    transform: rotate(-35deg);
    float: right;
    border-radius: 2px;
    &:after {
      content:"";
      background-color: white;
      width: 15px;
      height: 4px;
      display: block;
      float: right;
      border-radius: 10px 10px 10px 10px;
      transition: all $duration $easing;
      z-index: -1;
    }
  }
}

.active {
   .toggler__left:after {
    transform-origin: center center;
    transform: rotate(-70deg);
  }
  .toggler__right:after {
    transform-origin: center center;
    transform: rotate(70deg);
  }
}
</style>
